/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.10.3",
    versionName: "0.7.0-nightly.2026.10.3",
    versionChannel: "nightly",
    buildDate: "2026-10-03T00:18:03.917Z",
    commitHash: "e5158f51361917200520674bb887aa6a574bbf1a",
};
